import myTheme from "common/theme";

export default theme => ({
    ...myTheme,
    ...{
        fab: {
            position: "absolute",
            right: '20px',
            bottom: '20px',
        },
    }
});